export const expeditionLinks = {
  portfolio: "https://app.notion.com/p/Expedition158-3d1f59d27d7180fe9e23f887cd6aeb10",
  youtube: "https://www.youtube.com/watch?v=iG57KTDhf0o&list=PLB_KDWv0W5Qo&index=5",
  source: "https://github.com/SoExDobin/Expedition-Portfolio",
};
